export class Cbo {
  id: number;
  numero: string;
  nomeTitulo: string;
  descricaoTipo: string;
  usuarioAlteracao: number;
}
